import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { StoreAssetV2FragmentFragmentDoc } from '../fragments/storeAssetV2.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateStoreAssetMutationVariables = Types.Exact<{
  input: Types.CreateStoreAssetInput;
}>;


export type CreateStoreAssetMutation = { __typename?: 'Mutation', createStoreAsset: { __typename?: 'StoreAssetV2', id: string, creation_timestamp?: string | null, removed_at?: string | null, name: string, description?: string | null, internal_comment?: string | null, epc_tag: string, price?: number | null, is_billable?: boolean | null, is_recalled?: boolean | null, billing_start?: string | null, billing_end?: string | null, billing_frequency?: Types.BillingFrequency | null, billing_start_with_onboarding?: boolean | null, custom_fields: Array<{ __typename?: 'CustomFieldValue', id: string, name: string, type: Types.CustomFieldType, value?: string | null }>, item_type: { __typename?: 'ItemType', id: number, name: string, price?: number | null, category: Types.ItemTypeCategory, image_url?: string | null, color_hex_code?: string | null, custom_field_definitions?: Array<{ __typename?: 'CustomFieldDefinition', id: string, name: string, type: Types.CustomFieldType, required?: boolean | null, default_value?: string | null, depends_on?: { __typename?: 'CustomFieldDependency', field_id: string, value: string } | null }> | null } } };


export const CreateStoreAssetDocument = gql`
    mutation CreateStoreAsset($input: CreateStoreAssetInput!) {
  createStoreAsset(input: $input) {
    ...StoreAssetV2Fragment
  }
}
    ${StoreAssetV2FragmentFragmentDoc}`;
export type CreateStoreAssetMutationFn = Apollo.MutationFunction<CreateStoreAssetMutation, CreateStoreAssetMutationVariables>;

/**
 * __useCreateStoreAssetMutation__
 *
 * To run a mutation, you first call `useCreateStoreAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoreAssetMutation, { data, loading, error }] = useCreateStoreAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoreAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateStoreAssetMutation, CreateStoreAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStoreAssetMutation, CreateStoreAssetMutationVariables>(CreateStoreAssetDocument, options);
      }
export type CreateStoreAssetMutationHookResult = ReturnType<typeof useCreateStoreAssetMutation>;
export type CreateStoreAssetMutationResult = Apollo.MutationResult<CreateStoreAssetMutation>;
export type CreateStoreAssetMutationOptions = Apollo.BaseMutationOptions<CreateStoreAssetMutation, CreateStoreAssetMutationVariables>;